import tailwindConfig from '@/../tailwind.config';
import * as stripeJs from '@stripe/stripe-js';

export { default as withStripe } from './withStripe';

export const stripeCardElementOptions: stripeJs.StripeCardElementOptions = {
  hidePostalCode: true,
  iconStyle: 'solid',
  style: {
    base: {
      iconColor: tailwindConfig.theme.colors.primary[500],
      color: tailwindConfig.theme.colors.neutral[900],
      fontWeight: 'normal',
      fontFamily: tailwindConfig.theme.fontFamily.body.join(','),
      fontSize: 'initial',
      fontSmoothing: 'antialiased',
      ':-webkit-autofill': { color: tailwindConfig.theme.colors.neutral[900] },
      '::placeholder': { color: tailwindConfig.theme.colors.neutral[700] },
    },
    invalid: {
      iconColor: tailwindConfig.theme.colors.danger[500],
      color: tailwindConfig.theme.colors.danger[900],
    },
  },
};
